type RequestSuffix = 'getRepositories' | 'getOrganizations';

export const URL = (suffix: RequestSuffix) =>
	`/gateway/api/devai-core/v1/dev-agents/autoreview-github/${suffix}`;

export const SET_CODE_REVIEWER_SETTING_URL = '/gateway/api/devai-core/public/v2/settings/set';
